import React from 'react';
import propTypes from 'prop-types';
import { intlShape } from 'common/components/intl/intlShape';

import { autoShip } from 'apps/cart/paths';
import { translateMessage, TranslatedMessage } from 'common/components/Intl';
import Button from 'common/components/Button';

export const InformationItem = ({ id, values = {} }, context) => {
  const translation = translateMessage(context.intl, id) || '';
  if (!translation.trim()) return null;

  return (
    <li>
      <TranslatedMessage id={id} values={values} />
    </li>
  );
};

InformationItem.contextTypes = {
  intl: intlShape,
};

export default function MembershipInformation(props) {
  return (
    <div className="CartUpsellBanner__information text--body--small">
      <h5 className="heading--small">
        <TranslatedMessage id="cart.membership_information.learn_more.title" />
      </h5>

      <ul className="text--body--small">
        <InformationItem id="cart.membership_information.learn_more.free_shipping" />
        <InformationItem id="cart.membership_information.learn_more.automatic_processing" />
        <InformationItem id="cart.membership_information.learn_more.first_access" />
        <InformationItem id="cart.membership_information.learn_more.customizable" />
        <InformationItem id="cart.membership_information.learn_more.cancel_anytime" />
        {props.subscribableVariantFreeFrequency && (
          <InformationItem
            id="cart.membership_information.learn_more.free_juul_pod_on_us"
            values={{
              freePackFrequency: (
                <TranslatedMessage
                  id={`cart.membership_information.free_frequency`}
                  style={`ordinal`}
                  values={{ count: props.subscribableVariantFreeFrequency + 1 }}
                />
              ),
            }}
          />
        )}
      </ul>

      <p className="text--body--small">
        <TranslatedMessage id="cart.membership_information.learn_more.autoship_explaination" />
      </p>

      <p className="text--body--small">
        <TranslatedMessage id="cart.membership_information.learn_more.cancel_explaination" />
      </p>

      <p className="subheading--mini">
        <TranslatedMessage id="cart.membership_information.learn_more.fee_explaniation" />
      </p>

      <Button className="button--outline-soft" element="a" href={autoShip()}>
        <TranslatedMessage id="cart.upsell_banner.learn_more" />
      </Button>
    </div>
  );
}

MembershipInformation.propTypes = {
  minimumSubscriptionItems: propTypes.number.isRequired,
  subscribableVariantFreeFrequency: propTypes.number,
  requiredInstallmentCount: propTypes.number,
};
